export const config = (state) => state.config;

export const currentCollectivity = (state) => {
  const existingCollectivities = state.config.COLLECTIVITY_INFORMATION;
  return existingCollectivities.find((x) => window.location.origin.includes(x.urlPart));
};
